<div class="mat-dialog-container">
  <!-- 明細編輯開始 -->
  <div #head>
    <app-modal-header #modal_header [isDialog]="isDialog" [title]="title" [state]="srv.state" (onOkClick)="doOk($event)"
      (onCancelClick)="doCancel($event)">
    </app-modal-header>
  </div>
  <div class="jk-content">
    <div class="jk-grid-cols-4"> 
    <app-jknumberedit  label="編號" #WF001Com  id="WF001"  [(value)]="item.WF001" [required]="true"  placeholder="編號"  [readonly]="isBrowse"     >
    </app-jknumberedit>
    <app-jkedit  label="使用者" #WF002Com  id="WF002"  [(value)]="item.WF002" placeholder="使用者"  [readonly]="isBrowse"     >
    </app-jkedit>
    <app-jkedit  label="分類" #WF003Com  id="WF003"  [(value)]="item.WF003" placeholder="分類"  [readonly]="isBrowse"     >
    </app-jkedit>
    <app-jkedit  label="名稱" #WF004Com  id="WF004"  [(value)]="item.WF004" placeholder="名稱"  [readonly]="isBrowse"     >
    </app-jkedit>
    <app-jkedit  label="網址" #WF005Com  id="WF005"  [(value)]="item.WF005" placeholder="網址"  [readonly]="isBrowse"     >
    </app-jkedit>
    <app-jkedit  label="自行排序碼" #WF006Com  id="WF006"  [(value)]="item.WF006" placeholder="自行排序碼"  [readonly]="isBrowse"     >
    </app-jkedit>
    <app-jknumberedit  label="點閱次數" #WF007Com  id="WF007"  [(value)]="item.WF007" placeholder="點閱次數"  [readonly]="isBrowse"     >
    </app-jknumberedit>
    <app-jknumberedit  label="上層編號" #WF008Com  id="WF008"  [(value)]="item.WF008" placeholder="上層編號"  [readonly]="isBrowse"     >
    </app-jknumberedit>

    </div>
  </div>
</div>